//Pages
export const HomePage = "homePage";
export const HeaderMenu = "header";
export const DocumentsPage = "documentsPage";
export const svg = "svg";
export const adminPage = 'adminPage';
//homepage Labels
export const mainHeader = "mainHeader";
export const subHeader = "subHeader";
export const dragndrop ="dragndrop";
export const browse ='browse';
export const uploaded = 'uploaded';
export const files = 'files';
export const uploadCompleted = 'uploadCompleted';
export const uploading = 'uploading';
export const tagAllMessage = "tagAllMessage";
export const addTagsToAllFiles ='addTagsToAllFiles';
export const longTimeMsg = 'longTimeMsg';
export const timeMsg = "timeMsg";
export const saving = "saving";
export const pleaseWait = "pleaseWait";
export const goToDocs = "goToDocs";
export const fileUploadFailed = 'fileUploadFailed';
export const fileLabel = 'fileLabel';
export const isInvalidMessage = 'isInvalidMessage';
export const docUpdateToasterMessage = 'docUpdateToasterMessage';
export const sizeLimitExceeded = 'sizeLimitExceeded';
export const addTags = "addTags";
export const editTags = "editTags";
export const banner = "banner";
export const of = "of";
export const uploadLimit = "uploadLimit";
export const filesExceeded = "filesExceeded";
export const actions = "actions";





// Admin Labels
export const rolePermissions = "rolePermissions";
export const userAddedTitleToaster = "userAddedTitleToaster";
export const userTabName ='userTabName';
export const addUserButton ='addUserButton';
export const addBulkUsersButton ='addBulkUsersButton';
export const addUserTitle ='addUserTitle';
export const editUserTitle ='editUserTitle';
export const deleteUserTitle ='deleteUserTitle';
export const addUserTitleMessage ='addUserTitleMessage';
export const editUserTitleMessage ='editUserTitleMessage';
export const deleteUserTitleMessage ='deleteUserTitleMessage';
export const emailUniqueMsg = 'emailUniqueMsg';
export const roleTabName ='roleTabName';
export const addRoleButton ='addRoleButton';
export const addRoleTitle ='addRoleTitle';
export const editRoleTitle ='editRoleTitle';
export const deleteRoleTitle ='deleteRoleTitle';
export const addRoleTitleMessage ='addRoleTitleMessage';
export const editRoleTitleMessage ='editRoleTitleMessage';
export const deleteRoleTitleMessage ='deleteRoleTitleMessage';
export const deleteNotAllowedMessage = "deleteNotAllowedMessage";
export const activeText = "activeText";
export const inactiveText = "inactiveText";
export const editUserToasterHeader = "editUserToasterHeader";
export const addUserToasterHeader = "addUserToasterHeader";
export const networkTabName = "networkTabName";
export const addNetworkUploadTitle = "addNetworkUploadTitle";
export const addNetworkUploadMessage = "addNetworkUploadMessage";
export const editNetworkUploadTitle = "editNetworkUploadTitle";
export const editNetworkUploadMessage = "addNetworkUploadButton";
export const deleteNetworkUploadTitle = "addNetworkUploadButton";
export const deleteNetworkUploadMessage = "addNetworkUploadButton";
export const addNetworkUploadButton = "addNetworkUploadButton";
export const adminTabName = "adminTabName";

//menu Labels
export const logo = "logo";
export const home = "home";
export const documents = "documents";
export const admin = "admin";
export const unAuthorizedMessage = "unAuthorizedMessage";
export const breadCrumbNews = "breadCrumbNews";
export const breadCrumbDataSource = "breadCrumbDataSource";
export const breadCrumbAdmin = "breadCrumbAdmin";

//documents page
export const graphFieldName = 'graphFieldName';
export const doughNutNoDataFound = 'doughNutNoDataFound';
export const newsLimit ="newsLimit";
export const bulkUsersSavedToasterTitle ="bulkUsersSavedToasterTitle";
export const bulkUsersSavedToasterMessage = "bulkUsersSavedToasterMessage";
export const dragndropBulkMessage = "dragndropBulkMessage";
export const filenameMissingErrorTitle ="filenameMissingErrorTitle";
export const filenameMissingErrorMessage = "filenameMissingErrorMessage";
export const metadataErrorTitle = "metadataErrorTitle";
export const metadataErrorMessage = "metadataErrorMessage";
export const fileNameError = "fileNameError";
export const docDownloadingMessage = "docDownloadingMessage";
export const docDownloadingTitle = "docDownloadingTitle";
export const docDeletedMessage = "docDeletedMessage";
export const dataDeleted = "dataDeleted";
export const saveToasterMessage = 'saveToasterMessage';
export const allDocumentsHeading = "allDocumentsHeading";
export const myDocumentsHeading = "myDocumentsHeading";
export const downloadProgressMessage = "downloadProgressMessage";
export const downloadSuccessfulMessage ="downloadSuccessfulMessage";
export const downloadWarningMessage ="downloadWarningMessage";
export const showing = "showing";
export const tabName = "tabName";
export const uploadButton ="uploadButton";
export const editToaster= 'editToaster';
export const editToasterMessage ='editToasterMessage';
export const addDocPopUp ='addDocPopUp';
export const editDocPopUp ='editDocPopUp';
export const deleteDocPopUp ='deleteDocPopUp';
export const addButton ='addButton';
export const saveButton ='saveButton';
export const saveFileButton ='saveFileButton';
export const cancelButton ='cancelButton';
export const deleteButton ='deleteButton';
export const deleteMessage ='deleteMessage';
export const recent ='recent';
export const keywordSearchMsg ='keywordSearchMsg';
export const myDocInsideAllDocPage = "myDocInsideAllDocPage";
export const showMsgPagination = 'showMsgPagination';
export const homeBreadCrumb = "homeBreadCrumb";
export const progress = "progress";
export const success = "success";
export const warning = "warning";
export const sortByMsg="sortByMsg";
export const deleteTitle = 'deleteTitle';
export const noRecordsMessage = 'noRecordsMessage';
export const results = 'results';
export const mydocbanner = "mydocbanner";
export const selectedText = "selectedText";
export const addBulkUserHeader = "addBulkUserHeader";
export const bulkUploadButton = "bulkUploadButton";
export const downloadTemplateMsg1 = "downloadTemplateMsg1";
export const downloadTemplateMsg2 = "downloadTemplateMsg2";
export const downloadTemplateMsg3 = "downloadTemplateMsg3";
export const downloadTemplateMsg4 = "downloadTemplateMsg4";
export const downloadTemplateButton  = "downloadTemplateButton";
export const howToUpload = "howToUpload";
export const supported = "supported";
export const updateSupported = "updateSupported";
export const invalidFileBulkError = "invalidFileBulkError";
export const invalidExcelBulkError = "invalidExcelBulkError";
export const blankCellsBulkError = "blankCellsBulkError";
export const invalidRolesBulkError = "invalidRolesBulkError";
export const duplicateEmailsInExcelBulkError = "duplicateEmailsInExcelBulkError";
export const invalidEmailsInExcelBulkError = "invalidEmailsInExcelBulkError";
export const duplicateEmailsBulkError = "duplicateEmailsBulkError";
export const other = "Others";
export const genInfoHeading = "genInfoHeading";
export const versionHistoryHeading = "versionHistoryHeading";





//svg
export const upload ='upload';
export const tagAll = "tagAll";
export const notification ="notification";
export const footer = "footer";
export const evalueservelogo = 'evalueservelogo';
export const deletePopUpIcon = 'deletePopUpIcon';
export const sortIcon = 'sortIcon';
export const deleteIcon = 'deleteIcon';
export const editIcon = 'editIcon';
export const downloadIcon = 'downloadIcon';
export const checkCircleIcon = 'checkCircleIcon';
export const reloadIcon = 'reloadIcon';
export const successIcon = 'successIcon';
export const errorIcon = 'errorIcon';
export const iIcon = 'iIcon';
export const uploadIcon = 'uploadIcon';
export const addIconFile ='addIconFile';
export const editIconFile ='editIconFile';
export const deleteIconFile ='deleteIconFile';
export const mandatoryFieldErrorIcon = 'mandatoryFieldErrorIcon';
export const passwordReset = 'passwordReset'
export const resetIcon ='resetIcon';
export const docPrivateIcon ='docPrivateIcon';
export const docPublicIcon ='docPublicIcon';
export const docGroupIcon ='docGroupIcon';


















